module.exports = __webpack_public_path__ + "static/teriyakiAppIcon-18393a36f01b211ada61e55fc519830c.jpg";